import type { LinkProps } from './Link';

/**
 * Is this a URL (string starting with http(s)), or a path or react-router Link
 * config object?
 */
export const isUrl = (to: LinkProps['to']): to is string =>
  typeof to === 'string' && /^https?:\/\//.test(to);
